import {XauditModel} from '../xaudit.model';

export class CfgARPaymentProcessorModel extends XauditModel{
  PaymentProcessorId: string;
  LOCID: number;
  Name: string;
  enumARProcessorID: string;
  ConnectionParametersJSON: string = '';
  isLOCdefault: boolean;
  DeviceNumber: number;

  constructor() {

    super();
    this.PaymentProcessorId = '';
    this.LOCID = 0;
    this.Name = '';

    this.enumARProcessorID = '';
    this.ConnectionParametersJSON = '';
    this.isLOCdefault = false;
    this.DeviceNumber = 0;

  }


}
